export const MODULE_NAME = 'extensionFramework';
export const REDUCER_NAMESPACE = 'EXTENSION_FRAMEWORK';
